import React from "react";
import CustomButton from "../../components/CustomButton";
import ExcelIcon from "../../assets/images/excel.svg";
function CartTitle(props) {
  return (
    <React.Fragment>
      <div className="d-flex justify-content-between flex-column flex-lg-row light-border-bottom header-bg main-title mb-3 align-items-center py-2 px-2 rounded">
        <div className="CartTitle d-flex align-items-center  justify-content-lg-start justify-content-center">
          <h4 className="text-light text-capitalize m-0 ml-2">
            <span>{props.title}</span>
          </h4>
        </div>

        <div className="d-flex w-100 ml-0 ml-lg-2">
          {/* <div className="">
            <input type="search" placeholder="search" className="Searchbox" />
          </div> */}
          <div className="d-flex justify-content-lg-end justify-content-between align-items-center w-100 mobile_filter_btn">
            <div
              className={`inner-text text-light d-flex flex-row justify-content-between align-items-center mr-4 ${props.innerTextClass}`}
            >
              <h5 className="title-bar mb-0 mr-1">
                <span></span> <span>{props.textTitle} </span>{" "}
              </h5>
              <h5 className="m-0">{props.preRegisteredUserCount}</h5>
            </div>
            <div className="d-flex justify-content-between">
              {props.handleAddToggle && (
                <CustomButton
                  customType={"button"}
                  name={props.ButtonRight}
                  customClass={`btn-outline-light bg-none btnthemeColor mx-3 ${props.customClass}`}
                  customClick={() => props.handleAddToggle()}
                />
              )}
              {props.handleToggle && (
                <CustomButton
                  customType={"button"}
                  name={props.Name}
                  customClass={`btn-outline-light bg-none btnthemeColor ${props.customClass}`}
                  customClick={() => props.handleToggle()}
                />
              )}

              <span className={`excelicon mx-2 ${props.iconClass}`}>
                <img
                  src={ExcelIcon}
                  alt="icon"
                  onClick={() => props.customExcelClick()}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default CartTitle;
